var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompartir = function SvgCompartir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "compartir_svg__Capa_2",
    viewBox: "0 0 31.73 32.78"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "compartir_svg__Capa_1-2",
    d: "M.75 32.78c-1.8-3.85-.2-11.12 3.27-15.8 3.44-4.64 8.15-7.2 13.83-8.27V0c4.67 4.71 9.36 9.43 13.88 14-4.34 4.37-9.03 9.09-13.91 13.99 0-2.49-.09-4.9.03-7.31.08-1.48-.5-1.91-1.87-1.98-6.23-.32-12.36 4.44-14.48 11.33-.26.84-.47 1.69-.76 2.74Z",
    fill: "#fff"
  })));
};
export default SvgCompartir;